/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.SET_TELEGRAM_NEW_DIALOG_VISIBLE]: (state, payload) => {
    state.telegramNewDialogVisible = payload;
  },
  [types.SET_TELEGRAM_SELECTED_COUNTRY]: (state, payload) => {
    state.telegramSelectedCountry = payload;
  },

  [types.REQUEST_TELEGRAM_CODE_REQUEST]: state => {
    state.loadingTelegramCodeRequest = true;
    state.telegramCodeRequestFailed = false;
    state.telegramCodeRequestSuccess = false;
    state.telegramClientStatus = null;
    state.telegramCodeRequestError = null;
  },
  [types.REQUEST_TELEGRAM_CODE_SUCCESS]: (state, payload) => {
    state.loadingTelegramCodeRequest = false;
    state.telegramClientStatus = payload.message;
    state.telegramCodeRequestSuccess = true;
    state.telegramCodeRequestFailed = false;
  },
  [types.REQUEST_TELEGRAM_CODE_FAILURE]: (state, payload) => {
    state.loadingTelegramCodeRequest = false;
    state.telegramCodeRequestSuccess = false;
    state.telegramCodeRequestFailed = true;
    state.telegramCodeRequestError = payload;
  },

  [types.SIGN_IN_TELEGRAM_REQUEST]: state => {
    state.loadingTelegramSignIn = true;
    state.telegramSignInFailed = false;
    state.telegramSignInSuccess = false;
    state.telegramSignInStatus = null;
    state.telegramStatusMessage = null;
  },
  [types.SIGN_IN_TELEGRAM_SUCCESS]: (state, payload) => {
    state.loadingTelegramSignIn = false;
    state.telegramSignInSuccess = true;
    state.telegramSignInFailed = false;
    state.telegramSignInStatus = payload.status;
    state.telegramStatusMessage = payload.message;
  },
  [types.SIGN_IN_TELEGRAM_FAILED]: (state, error) => {
    state.loadingTelegramSignIn = false;
    state.telegramSignInFailed = true;
    state.telegramSignInSuccess = false;
    state.telegramSignInError = error;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/telegram/mutations.js